import React, { lazy, Suspense } from 'react';

const LazyMcoLsvOrderForm = lazy(() => import('./McoLsvOrderForm'));

const McoLsvOrderForm = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyMcoLsvOrderForm {...props} />
  </Suspense>
);

export default McoLsvOrderForm;
